import { useSelector } from "react-redux";

import { FrmTextField } from "components/formFields/FrmTextField";

import { i18n } from "services/i18nService";
import { isPersistedRecord } from "services/utility/misc";

import { getObjectFromFullString } from "appConstants";

export function FrmNumber(props) {
  const {
    onValueChange,
    label,
    error,
    value,
    recordId,
    name = "number",
    placeholder,
    objectType,
  } = props;

  const { nextRefNumberSetString } = objectType
    ? getObjectFromFullString(objectType)
    : null;

  // Check if this object type has nextRefNumberSet configured
  const hasNextRefNumberSet = useSelector((state) =>
    nextRefNumberSetString
      ? state.userCompanySettings.settings[nextRefNumberSetString]
      : false
  );

  // If placeholder is explicitly passed, use it. Otherwise check the setting.
  const effectivePlaceholder =
    placeholder ??
    (hasNextRefNumberSet ? i18n("frmLabel.AssignedUponSave") : "");

  return (
    <FrmTextField
      name={name}
      value={value}
      label={label}
      error={error}
      sx={{ width: "19rem" }}
      maxLength={21}
      onValueBlur={onValueChange}
      placeholder={isPersistedRecord(recordId) ? "" : effectivePlaceholder}
      dataTesting="number"
    />
  );
}
